import { ComputeExpenseLineItemTotalsUseCase } from './ComputeExpenseLineItemTotals'

export const computeExpenseLineItemTotalsUseCase =
  new ComputeExpenseLineItemTotalsUseCase()

export {
  ComputeExpenseLineItemTotalsUseCase,
  round2,
  parsePercentageOrZero,
} from './ComputeExpenseLineItemTotals'
export type { TaxMode } from './ComputeExpenseLineItemTotals'
